import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

interface BackButtonProps {
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, className, style }) => {
  return (
    <motion.button 
      className={`back-button-hover ${className || ''}`}
      onClick={onClick}
      whileTap={{
        backgroundColor: 'rgba(79, 70, 229, 0.15)',
        transition: { duration: 0 }
      }}
      animate={{
        backgroundColor: 'var(--card-background)',
        transition: { duration: 0 }
      }}
      style={{
        borderRadius: '25px',
        padding: '6px',
        boxShadow: 'var(--shadow-sm)',
        border: '1px solid var(--border-color)',
        cursor: 'pointer',
        width: '36px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        WebkitTapHighlightColor: 'transparent',
        ...style
      }}
    >
      <ArrowLeft size={18} color="var(--text-primary)" />
    </motion.button>
  );
};

export default BackButton; 